
import { Component, Prop, Vue } from "vue-property-decorator";
import { Notification, NotificationState } from '@/mixins/NotificationMixin';

@Component
export default class NotificationSummary extends Vue {
    @Prop({ required: true }) notificationsToSend!: NotificationState[];
    @Prop({ required: true }) notificationValidationErrorsByTemplate!: Map<number, string[]>;

    hasErrors(notification: NotificationState): boolean {
        if (notification.skipped) {
            return false;
        }
        const templateId = notification.notificationTemplate && notification.notificationTemplate.notificationTemplateId ? notification.notificationTemplate.notificationTemplateId : 0;
        return this.notificationValidationErrorsByTemplate.has(templateId) && (this.notificationValidationErrorsByTemplate.get(templateId)?.length ?? 0) > 0;
    }

    getErrors(notification: NotificationState): string[] {
        if (notification.skipped) {
            return [];
        }
        const templateId = notification.notificationTemplate && notification.notificationTemplate.notificationTemplateId ? notification.notificationTemplate.notificationTemplateId : 0;
        return this.notificationValidationErrorsByTemplate.get(templateId) || [];
    }

    isSkipped(notification: NotificationState): boolean {
        return !!notification.skipped;
    }
}
